module.exports = __webpack_public_path__ + "img/el4.0113e824.png";